<template>
  <lego-accordion-item
    :title="title"
    :expand="isExpand"
    :index="isExpand ? 0 : 1"
    expandable
    class="scpm-sub-tree"
  >
    {{ title }}
    <template #expand>
      <div
        class="lego-dropdown__item"
        :class="{
          'lego-dropdown__item--active': isActive(product)
        }"
        v-for="(product, idx) in items"
        @click.stop="clickItem({ ...product, item })"
        :key="idx"
      >
        <div
          class="lego-dropdown__label"
          :class="{ 'lego-dropdown__selected': isActive(product) }"
          :id="`dropdown-child-${product.typeOrder}`"
        >
          <span v-lego-tooltip:ellipsis="product.text" class="ellipsis">
            {{ product.text }}
          </span>
        </div>
      </div>
    </template>
  </lego-accordion-item>
</template>

<script>
import i18nMixin from '@/mixins/i18n.mixin.js';

export default {
  mixins: [i18nMixin],
  name: 'scpm-sub-tree-dropdown',
  emits: ['click'],
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    items: {
      type: [Array],
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    modelValue: {
      type: String,
      default: ''
    }
  },
  computed: {
    isExpand() {
      return this.items.some((item) => item.value.toLowerCase() === this.modelValue.toLowerCase());
    }
  },
  methods: {
    clickItem(item) {
      this.$emit('click', item);
    },
    isActive(item) {
      return item.value.toLowerCase() === this.modelValue.toLowerCase();
    }
  }
};
</script>

<style lang="scss" scoped>
.scpm-sub-tree {
  width: 100%;

  :deep .accordion-list-item__main {
    padding-left: 0px !important;
  }

  :deep .accordion-list-item__expand {
    .lego-dropdown__item {
      padding-left: 51px !important;
    }

    .lego-dropdown__item--active {
      background-color: rgba(54, 79, 199, 0.12);
    }
  }
}
</style>
